/**
 * Student portal session user.type values (my-txt /auth/account).
 */
export const MY_TXT_SESSION_USER_TYPES = [
  'txter',
  'alumni',
  'user',
  'other',
  'scla-applicant',
  'lil',
] as const;

export type MyTxtSessionUserType =
  (typeof MY_TXT_SESSION_USER_TYPES)[number];

// Named type groupings — use these in routeAccess.config.ts to gate routes.
// All routes use MY_TXT_SESSION_USER_TYPES (everyone) by default; narrow by
// swapping in a more specific group when product rules require it.

/** Active program participants only. */
export const ACTIVE_STUDENT_TYPES = ['txter'] as const;

/** Students past and present — active txters + alumni. */
export const STUDENT_AND_ALUMNI_TYPES = ['txter', 'alumni'] as const;

/** Students who signed up on My TXT (sign-up creates type "user"). */
export const SIGNED_UP_STUDENT_TYPES = ['user'] as const;

/** Accounts that may open the SCLA application. Alumni are excluded. */
export const SCLA_APPLICATION_USER_TYPES = [
  'txter',
  'user',
  'other',
  'scla-applicant',
  'lil',
] as const;
